import React from 'react';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import WalletPurchaseButton from './WalletPurchaseButton';
import styles from './WalletEmptyState.module.css';

/** Nenhum pacote ainda: ilustração leve em CSS e o atalho para vender o primeiro. */
function WalletEmptyState({ onPurchase }) {
  return (
    <section className={styles.card}>
      <div className={styles.illustration} aria-hidden="true">
        <span className={styles.halo} />
        <span className={styles.ticket}><ConfirmationNumberOutlinedIcon /></span>
        <span className={`${styles.badge} ${styles.badgeLeft}`}>10x</span>
        <span className={`${styles.badge} ${styles.badgeRight}`}>
          <span className={styles.bar}><span className={styles.barFill} /></span>
        </span>
      </div>

      <h3 className={styles.title}>Nenhum pacote comprado</h3>
      <p className={styles.text}>
        Ao vender um pacote, as sessões ficam aqui, com saldo por procedimento, validade e
        cada uso registrado.
      </p>

      <WalletPurchaseButton onClick={onPurchase} />
    </section>
  );
}

export default WalletEmptyState;
